/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

export type ConsentSetting =
  (typeof ConsentSetting)[keyof typeof ConsentSetting]

export const ConsentSetting = {
  HALF_HOURLY: "HALF_HOURLY",
  DAILY: "DAILY",
  MONTHLY: "MONTHLY",
  NO_CONSENT: "NO_CONSENT",
} as const
